import { Store } from '@/Core/Models/Stores'
import BillingModel from '@/Modules/Dashboard/models/MarketerBilling'
import { Component, MapGetter, Vue } from 'types-vue'

@Component
export default class BillingSection extends Vue {
  @MapGetter(Store.BillingWitget) protected billing: BillingModel[]
}